import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { ApplicationState } from 'store';
import { AcademyState } from 'store/modules/academy_store/types';
import { Chip } from './styles';

const AcademyLiveChip: React.FC = () => {
  const history = useHistory();
  const { pathname } = useLocation();
  const { liveNow, floatingState } = useSelector<ApplicationState, AcademyState>(
    (s) => s.session.academy,
  );

  const onLivePage = pathname === '/academy' || pathname.startsWith('/academy/ao-vivo');

  // Só aparece quando há live no ar, o flutuante está minimizado e não estamos na aba AO VIVO.
  if (!liveNow || !liveNow.embed_url || floatingState !== 'minimized' || onLivePage) {
    return null;
  }

  return (
    <Chip
      type="button"
      onClick={() => history.push('/academy/ao-vivo')}
      title="Assistir à transmissão ao vivo"
    >
      <span className="live-dot" />
      Ao vivo
    </Chip>
  );
};

export default AcademyLiveChip;
